<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>反馈信息管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%">
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->

        <el-table-column align="center" type="index"></el-table-column>
        <!-- <el-table-column label="编号" prop="id" width="80px"></el-table-column> -->
        <el-table-column label="类型" prop="yijianType" width="160px"></el-table-column>
        <el-table-column label="内容" prop="yijianContent" width="250px"></el-table-column>

        <el-table-column label="创建时间" prop="create_at" align="center" width="120px"> </el-table-column>

        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-delete" @click="deleteFeedback(scope.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  data () {
    return {
      canLook: 1,
      queryInfo: {
        pagenum: 1,
        pagesize: 10
      },
      total: 0,
      orderlist: [],
    }
  },

  created () {
    this.getOrderList()
  },

  methods: {

    async getOrderList () {
      const { data: res } = await this.$http.get('admin/getFeedbackList', { params: this.queryInfo })
      if (res.code !== 200) {
        return this.$message.error('获取列表失败！')
      }
      console.log(res)
      this.total = res.result.total
      this.orderlist = res.result.list
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },
    async deleteFeedback (id) {
      const confirmResult = await this.$confirm(
        '将删除此反馈信息, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/deleteFeedback', { id: id })
      if (res.code !== 200) {
        return this.$message.error('删除失败！')
      }
      this.$message.success('删除成功！')
      this.getOrderList()
    },


    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },

  }
}
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 30px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}
</style>
